<template>
    <span :title="longName">
        INC-{{ incident.IncidentDate | moment("YYYY-MM-DD") }} -
        <template v-if="incident.JobsiteId">
            JOB-{{ incident.JobsiteNumber }}
        </template>
        <template v-else>
            {{ incident.other_location }}
        </template>
    </span>
</template>

<script>
    export default {
        props: {
            incident: {
                type: Object,
                required: true
            }
        },

        data: function() {
            return {

            }
        },

        computed: {
            longName() {
                var name = this.incident.IncidentDate +' - ';

                //Check for a jobsite
                if(this.incident.JobsiteId)
                {
                    name += this.incident.JobsiteNumber + ' - ' + this.incident.JobsiteName;
                }
                else
                {
                    name += this.incident.other_location;
                }

                //send it
                return name;
            }
        },

        methods: {


        },

        mounted() {

        }
    }
</script>
